export class Cost {
    natureType: string = null;
    costCenter: string = null;
    executionUnity: string = null;
    valueClass: string = null;
    observation: string = null;
    sellingValue: number = 0;

    public populateFromServer(r: any) {
        if (r.natureType)
            this.natureType = r.natureType;

        if (r.costCenter)
            this.costCenter = r.costCenter;

        if (r.executionUnity)
            this.executionUnity = r.executionUnity;

        if (r.valueClass)
            this.valueClass = r.valueClass;

        if (r.observation)
            this.observation = r.observation;

        if (r.sellingValue)
            this.sellingValue = r.sellingValue;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/billing-letter/Cost.model.ts